import { formatUserDate } from 'owa-datetime';
import FileProviderItemViewState, {
    FileProviderItemType,
} from '../../store/schema/FileProviderItemViewState';
import { format, isStringNullOrWhiteSpace } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';

function getModifiedAriaString(item: FileProviderItemViewState): string {
    if (!item.modifiedTime) {
        return null;
    }

    const modifiedTime = formatUserDate(item.modifiedTime);

    if (!isStringNullOrWhiteSpace(item.modifiedBy)) {
        return format(strings.FilePickerItem_ModifiedByAriaText, item.modifiedBy, modifiedTime);
    } else {
        return format(strings.FilePickerItem_LastModifiedAriaText, modifiedTime);
    }
}

export default function getAriaLabelForFileProviderItem(item: FileProviderItemViewState): string {
    const ariaStringToUse =
        item.type === FileProviderItemType.Folder
            ? strings.FilePickerItem_FolderAriaText
            : strings.FilePickerItem_FileAriaText;
    const modifiedAriaText = getModifiedAriaString(item);
    const ariaLabel = modifiedAriaText
        ? format(ariaStringToUse, item.name, modifiedAriaText)
        : item.name;

    return ariaLabel;
}
